const $ = window.jQuery;


var $DOM = {};
var lastKnownScrollY = 0;
var currentScrollY = 0;
var ticking = false;

function throttle(func, timeFrame) {
    var lastTime = 0;
    return function() {
        var now = new Date();
        if (now - lastTime >= timeFrame) {
            func();
            lastTime = now;
        }
    };
}

function onScroll() {
    currentScrollY = window.pageYOffset;
    $('.choose-lang-select').trigger('mousedown');
    requestTick();
}

function requestTick() {
    if (!ticking) {
        requestAnimationFrame(update);
    }
    ticking = true;
}

function update() {
    if (currentScrollY < lastKnownScrollY) {
        pin();
        // if (currentScrollY < 100) {
        //     $DOM.header.addClass('transparent');
        // } else {
        //     $DOM.header.removeClass('transparent');
        // }
    } else if ((currentScrollY > lastKnownScrollY) && currentScrollY > 100) {
        unpin();
    }

    lastKnownScrollY = currentScrollY;
    ticking = false;
}

function pin() {

    if ($DOM.header.hasClass('header-unpin')) {
        $DOM.header.removeClass('header-unpin');
        $DOM.header.addClass('header-pin');
    }
}
// hide header menu
function unpin() {

    if ($DOM.header.hasClass('header-pin') || !$DOM.header.hasClass('header-unpin')) {
        $DOM.header.removeClass('header-pin');
        $DOM.header.addClass('header-unpin');
    }
}

function eventListener() {
    document.addEventListener('scroll', throttle(onScroll, 30), false);
}


const header = {

    init: () => {
        $DOM.header = $("#page-header");
        // $DOM.header.addClass('transparent');

        eventListener();
    }

}

export default header;